function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import { withIllustrationWrapper } from '../../components/atoms/Illustration/withIllustrationWrapper';
import { jsx as ___EmotionJSX } from "@emotion/react";

var IllustrationTlcAdvantage3 = function IllustrationTlcAdvantage3(props, ref) {
  return ___EmotionJSX("svg", _extends({
    width: "297",
    height: "244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), ___EmotionJSX("path", {
    opacity: ".3",
    d: "M15.21 185.784c-19.204-34.912-18.4-78.72-1.779-114.86C29.472 36.046 62.503 10.48 99.897 1.647c32.913-7.774 62.192 15.016 93.984 26.656 34.111 12.489 79.257 10.416 95.705 42.793 16.742 32.955-1.796 72.887-20.9 104.457-16.203 26.776-44.789 40.328-73.819 52.069-28.548 11.546-57.875 20.332-87.904 13.339-36.122-8.412-73.878-22.682-91.752-55.177z",
    fill: "url(#paint0_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M279.452 157.161l-275.689-1.16c1.265 16.236 9.941 36.67 24.871 51.414 21.92 21.648 68.29 34.405 96.955 36.337 28.665 1.933 85.152-18.941 110.444-34.791 22.018-13.797 32.881-29.765 43.419-51.8z",
    fill: "#fff",
    fillOpacity: ".7"
  }), ___EmotionJSX("g", {
    filter: "url(#filter0_d_250_6714)"
  }, ___EmotionJSX("path", {
    d: "M173.114 173.583c.203-.878 17.684-6.957 18.379-6.551.696.405 10.371 20.262 10.144 21.285-.227 1.023-21.819 8.438-22.799 7.599-.981-.84-5.961-21.296-5.724-22.333z",
    fill: "#fff"
  }), ___EmotionJSX("path", {
    opacity: ".68",
    d: "M197.048 186.2c-1.309.54-2.637 1.032-3.965 1.515-1.329.482-2.672.965-4.01 1.399-1.338.434-2.69.883-4.048 1.288l-2.033.608c-.686.183-1.362.386-2.053.555.657-.275 1.319-.522 1.976-.782l1.995-.733c1.328-.483 2.666-.941 4.009-1.395 1.343-.453 2.69-.883 4.043-1.288 1.352-.405 2.714-.815 4.086-1.167z",
    fill: "url(#paint1_linear_250_6714)"
  }), ___EmotionJSX("path", {
    opacity: ".68",
    d: "M196.024 182.808c-1.314.545-2.642 1.033-3.97 1.52-1.329.487-2.672.941-4.01 1.394-1.338.454-2.69.883-4.048 1.288l-2.033.608c-.681.188-1.362.386-2.048.56.652-.275 1.314-.521 1.975-.782l1.991-.738c1.328-.482 2.671-.965 4.009-1.394 1.338-.43 2.69-.883 4.048-1.288 1.357-.406 2.709-.816 4.086-1.168z",
    fill: "url(#paint2_linear_250_6714)"
  }), ___EmotionJSX("path", {
    opacity: ".68",
    d: "M194.807 179.484c-1.324.555-2.638 1.037-3.971 1.52-1.333.482-2.666.965-4.009 1.394-1.343.429-2.686.888-4.043 1.293l-2.034.608c-.685.183-1.367.386-2.052.555.652-.275 1.318-.522 1.975-.782l1.99-.733c1.329-.483 2.671-.965 4.014-1.395 1.343-.429 2.686-.883 4.043-1.288 1.358-.405 2.71-.82 4.087-1.172z",
    fill: "url(#paint3_linear_250_6714)"
  }), ___EmotionJSX("path", {
    opacity: ".75",
    d: "M182.209 176.251a3.038 3.038 0 0 1-1.207.589c-.218.043-.454.038-.667.096a2.39 2.39 0 0 0-.613.261 6.206 6.206 0 0 1-1.222.535c-.434.132-.885.2-1.339.203v-.048a4.832 4.832 0 0 1 1.189-.642 6.51 6.51 0 0 1 1.299-.299c.222-.023.44-.077.647-.159.208-.087.392-.227.595-.328a2.978 2.978 0 0 1 1.313-.251l.005.043z",
    fill: "url(#paint4_linear_250_6714)"
  })), ___EmotionJSX("path", {
    d: "M174.111 115.466c-2.232-1.013-1.662-3.98-1.106-5.862.555-1.881-1.111-2.412-.889-5.306.222-2.895 3.565-3.764 3.275-6.528-.29-2.764-1.391-2.895-1.169-5.978.222-3.082 2.212-4.645 2.898-9.403.686-4.756.556-8.626 5.207-12.939 4.652-4.313 18.138-4.265 22.703 4.646 2.44 4.757 1.222 6.195 1.884 8.293.662 2.1 1.773 2.895 1.662 5.308-.111 2.412-1.995 3.912-.995 6.566 1 2.653 2.56 3.739 2.898 5.162.666 2.986-1.285 4.236 0 5.64 2.285 2.494 4.763 3.208 2.768 8.848-1.995 5.64-35.504 3.213-39.136 1.553z",
    fill: "url(#paint5_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M185.158 98.648c-.314 3.435-.454 6.031-1.174 9.167-.362 1.592 10.854.665 10.854.665.372-1.447-.381-8.163-.695-9.306l-8.985-.526z",
    fill: "url(#paint6_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M177.743 83.572c-.28.212-.12 5.046.517 7.965.638 2.919 3.381 8.115 10.844 8.115 7.463 0 10.985-2.6 13.076-6.86.266-.531 2.145-.194 3.546-1.843 1.227-1.448 1.478-3.175.966-5.09-.512-1.916-2.531-2.248-4.063-1.549-.637.29-1.695-.371-2.289-1.327-.594-.955-2.729-1.548-3.246-1.93-.517-.38-.667-1.693-.966-2.137-.3-.444-1.845-.965-2.29-1.93-.444-.964-.212-1.254-.845-1.553-.633-.3-1.667-.733-2.034-1.177-.367-.444-.966-1.105-1.328-1.182-.362-.077-1.328.593-1.845 1.327a6.284 6.284 0 0 1-1.85 1.847c-.662.367-1.551.145-2.068 1.033-.517.887-.367 1.987-1.178 2.653-.812.666-2.106-.12-2.44.589a7.284 7.284 0 0 1-2.507 3.049z",
    fill: "url(#paint7_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M197.664 164.739a23.154 23.154 0 0 1-3.71.275c-.608 0-2.217-1.037-3.106-1.148-.613-.072-2.951.241-3.777.989-.275.251-.903 1.052-1.039 1.153-.444.333-4.83.753-5.096 1.274-1.661 3.15.203 8.515 2.261 9.745.782.483 6.622-.531 9.931-3.198.71-.575 6.009-2.287 6.908-2.591.898-.304-1.561-6.644-2.372-6.499z",
    fill: "url(#paint8_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M129.435 111.153c.125.507-5.797 2.451-6.314 2.49-.516.038-1.217-5.982-1.217-5.982l6.975.506s.391 2.321.556 2.986z",
    fill: "url(#paint9_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M129.976 108.77l-9.917-.965a.692.692 0 0 1-.686-.685V86.032a.69.69 0 0 1 .686-.685l9.917-.965a.69.69 0 0 1 .686.685v23.008a.689.689 0 0 1-.686.695z",
    fill: "#596068"
  }), ___EmotionJSX("path", {
    d: "M129.309 108.77l-9.912-.965a.685.685 0 0 1-.686-.685V86.032a.687.687 0 0 1 .686-.685l9.912-.965a.687.687 0 0 1 .686.685v23.008a.685.685 0 0 1-.686.695z",
    fill: "url(#paint10_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M119.842 87.682c.272 0 .492-.307.492-.685 0-.379-.22-.685-.492-.685-.273 0-.493.306-.493.685 0 .378.22.685.493.685z",
    fill: "#616160"
  }), ___EmotionJSX("path", {
    d: "M118.286 98.653c.44-1.157 9.7-1.597 10.53-.545.648.816.995 5.047.445 6.32-.551 1.274-9.477 3.59-10.753 2.485-1.019-.888-.995-6.214-.222-8.26z",
    fill: "url(#paint11_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M129.7 110.511c.676.116 1.425 1.665 1.565 2.331.643 2.976 2.488 5.726 8.526 9.817 5.313 3.609 18.94 5.973 27.359-2.986 1.836-1.93 5.058-5.365 8.212-8.235 3.429-3.112 6.999-5.351 7.632-5.307 1.319.072 12.303-.642 13.351-.198.72.299 2.377.931 4.42 1.746 3.381 1.351 8.835 3.122 14.08 6.513 5.971 3.86 12.675 12.274 13.55 22.087 1.806 20.355-7.347 31.456-20.085 33.931-.387.077-3.777.868-4.12 1.056a6.396 6.396 0 0 1-3.044.748c-1.106-.111-4.096-7.415-3.864-8.409.063-.285 2.237-1.182 3.319-1.293.41-.039 2.106-1.674 3.603-2.581 2.522-1.525 4.657-2.75 4.705-3.097h-37.996s-.164-11.579 1.217-19.028c.252-1.346-5.859 5.755-19.804 5.755-14.974 0-21.351-8.997-22.94-11.839-1.449-2.591-3.381-7.594-4.564-11.159-.232-.714-1.078-3.329-1.45-3.951a4.892 4.892 0 0 1-.768-2.716c-.019-.797 5.787-3.411 7.096-3.185z",
    fill: "url(#paint12_linear_250_6714)"
  }), ___EmotionJSX("path", {
    opacity: ".75",
    d: "M172.13 137.109c.483-3.314 2.106-10.025 2.44-11.627",
    stroke: "url(#paint13_linear_250_6714)",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), ___EmotionJSX("path", {
    opacity: ".75",
    d: "M209.213 156.32c2.381-2.6 4.087-6.576 3.459-13.508-.609-6.755-4.154-13.938-7.478-17.311",
    stroke: "url(#paint14_linear_250_6714)",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), ___EmotionJSX("path", {
    d: "M147.655 171.965l-2.009-3.473h-7.043l-2.01 3.473h11.062z",
    fill: "url(#paint15_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M147.037 170.692h-9.825c-.755 0-1.367.611-1.367 1.365v10.532c0 .754.612 1.365 1.367 1.365h9.825c.755 0 1.367-.611 1.367-1.365v-10.532c0-.754-.612-1.365-1.367-1.365z",
    fill: "url(#paint16_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M148.404 172.892h-12.559v8.858h12.559v-8.858z",
    fill: "url(#paint17_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M145.631 167.315h-7.018v1.177h7.018v-1.177z",
    fill: "url(#paint18_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M145.476 165.881h-6.709a.41.41 0 0 0-.411.41v.613c0 .227.184.41.411.41h6.709a.41.41 0 0 0 .411-.41v-.613a.41.41 0 0 0-.411-.41z",
    fill: "url(#paint19_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M144.791 176.481h-1.821v-1.828a.255.255 0 0 0-.256-.251h-1.184a.251.251 0 0 0-.251.251v1.823h-1.826a.25.25 0 0 0-.251.251v1.182a.234.234 0 0 0 .018.098.242.242 0 0 0 .136.138c.031.013.064.02.097.02h1.811v1.819a.253.253 0 0 0 .252.255h1.198a.256.256 0 0 0 .256-.255v-1.819h1.821a.258.258 0 0 0 .256-.256v-1.182a.258.258 0 0 0-.077-.176.25.25 0 0 0-.179-.07z",
    fill: "url(#paint20_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M127.937 170.291l-.985-3.005h-3.449l-.985 3.005h5.419z",
    fill: "url(#paint21_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M126.942 169.187h-3.424c-.755 0-1.367.611-1.367 1.365v8.728c0 .754.612 1.365 1.367 1.365h3.424c.755 0 1.367-.611 1.367-1.365v-8.728c0-.754-.612-1.365-1.367-1.365z",
    fill: "url(#paint22_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M128.309 171.092h-6.158v7.652h6.158v-7.652z",
    fill: "url(#paint23_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M126.947 166.268h-3.439v1.013h3.439v-1.013z",
    fill: "url(#paint24_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M126.662 165.033h-2.869a.41.41 0 0 0-.411.41v.42c0 .226.184.41.411.41h2.869a.41.41 0 0 0 .411-.41v-.42a.41.41 0 0 0-.411-.41z",
    fill: "url(#paint25_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M120.402 189.271l-2.454-1.206-1.304 2.648 2.449 1.207a1.497 1.497 0 0 0 1.129.074 1.472 1.472 0 0 0 .851-.745 1.48 1.48 0 0 0-.213-1.627 1.482 1.482 0 0 0-.458-.351z",
    fill: "url(#paint26_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M114.214 189.507l2.449 1.206 1.304-2.648-2.449-1.206a1.478 1.478 0 0 0-2.023 1.799c.12.366.378.671.719.849z",
    fill: "url(#paint27_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M115.62 179.019a1.232 1.232 0 1 0 0-2.463 1.232 1.232 0 0 0 0 2.463z",
    fill: "url(#paint28_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M115.195 179.13a1.231 1.231 0 1 0 .001-2.463 1.231 1.231 0 0 0-.001 2.463z",
    fill: "url(#paint29_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M111.123 177.871a1.23 1.23 0 0 0 0-2.46 1.23 1.23 0 1 0 0 2.46z",
    fill: "url(#paint30_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M110.717 177.697a1.23 1.23 0 1 0-1.232-1.23c0 .68.552 1.23 1.232 1.23z",
    fill: "url(#paint31_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M77.997 74.392h-.195c.081.007.168.02.195 0z",
    fill: "url(#paint32_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M77.663 74.419a34.306 34.306 0 0 0-.766 4.503c.36-2.228.752-4.244.812-4.523l-.046.02z",
    fill: "url(#paint33_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M76.783 79.646c0-.246.067-.492.1-.725-.027.24-.067.48-.1.725z",
    fill: "url(#paint34_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M78.442 72.257h.161a.477.477 0 0 0-.194 0 .126.126 0 0 0 0 .06.128.128 0 0 1 .033-.06zM80.519 72.323l-1.139-.08c.377.058.758.085 1.139.08z",
    fill: "#F4F3F4"
  }), ___EmotionJSX("path", {
    d: "M79.38 72.244a4.22 4.22 0 0 0-.805 0c.173-.027.446-.02.806 0z",
    fill: "url(#paint35_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M89.283 57.272a7.992 7.992 0 0 0 2.477 1.503c1.04.372 6.08 2.787 7.452 3.99a20.842 20.842 0 0 1 5.754 9.16c4.601-4.35 7.398-10.09 7.398-16.376 0-13.622-13.119-24.663-29.3-24.663-16.183 0-29.302 11.041-29.302 24.663 0 6.698 3.176 12.77 8.324 17.213a18.182 18.182 0 0 1 5.814-9.039 26.974 26.974 0 0 1 8.497-4.655 15.254 15.254 0 0 0 4.981-2.82s-1.218 6.57-1.332 9.112c-.056 2.328.1 4.657.467 6.957 2.623.22 7.038.738 9.55 1.124.066-2.335.126-4.137.152-5.088a58.116 58.116 0 0 0-.932-11.081z",
    fill: "url(#paint36_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M78.162 73.235c.045-.31.11-.617.193-.918a2.965 2.965 0 0 0-.193.918z",
    fill: "url(#paint37_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M78.009 74.379h-.287c-.06.279-.452 2.294-.812 4.522 0 .233-.067.48-.1.725a34.82 34.82 0 0 0 6.233.566 34.395 34.395 0 0 0 8.784-1.13c.153-1.85.246-3.067.246-3.067-.273-.326-11.88-1.623-14.064-1.616z",
    fill: "url(#paint38_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M95.49 60.511a25.55 25.55 0 0 0-.187-8.5c-.566-2.355-.939-7.423-1.032-8.46a19.813 19.813 0 0 0-1.132-4.696 7.873 7.873 0 0 0-6.587-4.064c-3.569-.093-5.993 1.104-7.145 2.068a9.524 9.524 0 0 0-3.39 6.977c-.08 2.262.353 6.08.094 7.516-.467 2.66-3.477 4.317-4.609 5.727a7.563 7.563 0 0 0-1.784 5.361",
    fill: "url(#paint39_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M88.43 52.868c0 2.994.353 5.042 2.664 5.62 2.664.666-1.219 7.051-4.795 7.051-3.576 0-9.496-6.385-7.858-7.143 3.103-1.41 3.663-2.255 3.084-6.365-.014-.3 6.905.837 6.905.837z",
    fill: "url(#paint40_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M87.352 38.522c-5.594 0-8.744 5.454-8.744 6.112 0 .659-.24-.332-1.179-.332-1.412 0-1.412 1.41-1.412 2.068 0 .659.287 3.1 3.01 3.1.287 0 1.699 3.758 7.06 3.758a6.599 6.599 0 0 0 6.273-4.069 6.578 6.578 0 0 0 .499-2.582c0-7.13-4.515-8.055-5.507-8.055z",
    fill: "url(#paint41_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M92.498 43.611l-.597.377.15.236.596-.377-.15-.236z",
    fill: "#717171"
  }), ___EmotionJSX("path", {
    d: "M88.584 46.41a2.478 2.478 0 0 1-.513-1.849c.113-1.057.999-1.643 2.358-1.563a1.847 1.847 0 0 1 1.752 1.217c.086.239.122.492.106.745a1.994 1.994 0 0 1-2.158 2.056 2 2 0 0 1-1.545-.606zm1.844-3.132c-1.205-.074-1.957.405-2.057 1.33a2.192 2.192 0 0 0 .446 1.63 1.706 1.706 0 0 0 1.332.511 1.733 1.733 0 0 0 1.878-1.775 1.561 1.561 0 0 0-1.599-1.696zM80.719 45.053a1.84 1.84 0 0 1 1.11-1.846c.237-.101.491-.152.748-.15 1.332-.08 2.237.506 2.357 1.564a2.518 2.518 0 0 1-.5 1.882 1.956 1.956 0 0 1-1.537.612 1.998 1.998 0 0 1-2.178-2.062zm1.871-1.683A1.56 1.56 0 0 0 81 45.053a1.729 1.729 0 0 0 1.878 1.776 1.719 1.719 0 0 0 1.332-.512 2.187 2.187 0 0 0 .446-1.63c-.094-.851-.76-1.33-1.832-1.33l-.233.013z",
    fill: "#717171"
  }), ___EmotionJSX("path", {
    d: "M84.835 44.894a4.32 4.32 0 0 1 1.998-.36c.441-.012.88.082 1.278.273l.153-.239a3.006 3.006 0 0 0-1.431-.313 4.594 4.594 0 0 0-2.145.393l.147.246zM80.952 44.441l.06-.272a7.84 7.84 0 0 0-1.905-.193 3.48 3.48 0 0 0-1.378.2l.127.252a3.332 3.332 0 0 1 1.251-.173c.62-.014 1.24.049 1.845.186z",
    fill: "#717171"
  }), ___EmotionJSX("path", {
    d: "M90.315 58.775c-.186 1.69-2.158 4.975-4.515 5.068-2.358.093-5.734-3.472-5.827-4.317-.093-.844-1.532 3.758-1.225 6.293.306 2.534.939 7.981.939 7.981l11.407.945s.666-5.634.286-8.361c-.38-2.727-1.065-7.61-1.065-7.61z",
    fill: "url(#paint42_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M91.814 75.922a.58.58 0 0 1 .246.093s-.093 1.217-.246 3.066a30.29 30.29 0 0 0 13.119-7.156 20.841 20.841 0 0 0-5.754-9.16c-1.372-1.203-6.413-3.617-7.452-3.99a7.993 7.993 0 0 1-2.444-1.503c.667 3.657.982 7.37.94 11.088 0 .95-.087 2.753-.154 5.088a8.095 8.095 0 0 1 1.898.406s-.06.791-.153 2.068z",
    fill: "url(#paint43_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M80.52 72.323a7.023 7.023 0 0 1-1.14-.08H78.416a.126.126 0 0 0-.06.06 7.327 7.327 0 0 0-.193.918 5.978 5.978 0 0 1-.153 1.144c4.625.275 9.233.79 13.805 1.544.093-1.278.153-2.07.153-2.07-.207-.272-7.672-1.203-11.448-1.516z",
    fill: "#F4F3F4"
  }), ___EmotionJSX("path", {
    d: "M77.709 74.372a.916.916 0 0 0 .286 0c.14-.066.14-2.042.42-2.135.486-.16 2.164.187 2.117.047a38.227 38.227 0 0 1-.466-6.957c.093-2.541 1.332-9.113 1.332-9.113a15.255 15.255 0 0 1-4.981 2.82 26.974 26.974 0 0 0-8.498 4.656 18.182 18.182 0 0 0-5.846 9.04 31.082 31.082 0 0 0 14.71 6.917c.413-2.667.926-5.275.926-5.275z",
    fill: "url(#paint44_linear_250_6714)"
  }), ___EmotionJSX("path", {
    d: "M93.658 67.554h.127a.372.372 0 0 0 .226-.478 11.408 11.408 0 0 1-.34-2.155c-.22-2.069-.519-4.896-2.077-6.791a.377.377 0 0 0-.664.204.377.377 0 0 0 .084.274c1.412 1.717 1.699 4.417 1.905 6.392.052.787.181 1.567.386 2.328a.373.373 0 0 0 .353.226z",
    fill: "#979797"
  }), ___EmotionJSX("path", {
    d: "M91.76 69.011a1.902 1.902 0 0 1 2.436-1.513 1.905 1.905 0 0 1 1.33 1.559 1.9 1.9 0 0 1-1.881 2.162 2.072 2.072 0 0 1-1.885-2.208zm.752 0a1.164 1.164 0 0 0 2.05.421 1.164 1.164 0 0 0-.917-1.877 1.333 1.333 0 0 0-1.12 1.456h-.013zM77.01 67.655a.38.38 0 0 0 .372-.38c.01-3.197.576-6.367 1.672-9.371a.372.372 0 0 0-.233-.472.38.38 0 0 0-.48.232 28.363 28.363 0 0 0-1.711 9.611.379.379 0 0 0 .38.38z",
    fill: "#979797"
  }), ___EmotionJSX("path", {
    d: "M74 77.705a.334.334 0 0 0 .24-.093.366.366 0 0 0 .04-.526c-1.333-1.543-1.06-4.516-.134-6.531.76-1.67 1.871-2.62 3.05-2.62 2.664 0 3.65 2.866 3.956 4.096a.371.371 0 0 0 .452.28.38.38 0 0 0 .28-.46c-.732-2.966-2.444-4.655-4.661-4.655-1.486 0-2.844 1.11-3.736 3.06-1.052 2.28-1.332 5.533.253 7.316a.38.38 0 0 0 .26.133z",
    fill: "#979797"
  }), ___EmotionJSX("path", {
    d: "M74.512 78.735a.799.799 0 1 0 .002-1.597.799.799 0 0 0-.002 1.597z",
    fill: "#979797"
  }), ___EmotionJSX("path", {
    d: "M73.34 77.937a1.177 1.177 0 0 1 1.412-1.154 1.178 1.178 0 1 1-1.411 1.154zm.753 0a.426.426 0 0 0 .42.425.427.427 0 0 0 .426-.425.425.425 0 0 0-.723-.297.419.419 0 0 0-.123.297z",
    fill: "#979797"
  }), ___EmotionJSX("path", {
    d: "M74.559 78.456a.473.473 0 1 0 0-.945.473.473 0 0 0 0 .945z",
    fill: "#fff"
  }), ___EmotionJSX("path", {
    d: "M115.298 79.37a3.73 3.73 0 1 0 0-7.46 3.73 3.73 0 0 0 0 7.46z",
    fill: "url(#paint45_linear_250_6714)"
  }), ___EmotionJSX("defs", null, ___EmotionJSX("filter", {
    id: "filter0_d_250_6714",
    x: "167.105",
    y: "162.012",
    width: "40.535",
    height: "40.97",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, ___EmotionJSX("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), ___EmotionJSX("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), ___EmotionJSX("feOffset", {
    dy: "1"
  }), ___EmotionJSX("feGaussianBlur", {
    stdDeviation: "3"
  }), ___EmotionJSX("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), ___EmotionJSX("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), ___EmotionJSX("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_250_6714"
  }), ___EmotionJSX("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_250_6714",
    result: "shape"
  })), ___EmotionJSX("linearGradient", {
    id: "paint0_linear_250_6714",
    x1: ".884",
    y1: "73.966",
    x2: "296.112",
    y2: "75.366",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#64C9C3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#50B3C8"
  })), ___EmotionJSX("linearGradient", {
    id: "paint1_linear_250_6714",
    x1: "193.602",
    y1: "191.724",
    x2: "186.887",
    y2: "185.813",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#50B3CA"
  }), ___EmotionJSX("stop", {
    offset: ".34",
    stopColor: "#4CB0C8"
  }), ___EmotionJSX("stop", {
    offset: ".66",
    stopColor: "#40A9C2"
  }), ___EmotionJSX("stop", {
    offset: ".99",
    stopColor: "#2D9CB7"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#2C9BB7"
  })), ___EmotionJSX("linearGradient", {
    id: "paint2_linear_250_6714",
    x1: "5081.5",
    y1: "1973.43",
    x2: "5053.5",
    y2: "1857.81",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#50B3CA"
  }), ___EmotionJSX("stop", {
    offset: ".34",
    stopColor: "#4CB0C8"
  }), ___EmotionJSX("stop", {
    offset: ".66",
    stopColor: "#40A9C2"
  }), ___EmotionJSX("stop", {
    offset: ".99",
    stopColor: "#2D9CB7"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#2C9BB7"
  })), ___EmotionJSX("linearGradient", {
    id: "paint3_linear_250_6714",
    x1: "5064.65",
    y1: "1931.01",
    x2: "5036.65",
    y2: "1815.39",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#50B3CA"
  }), ___EmotionJSX("stop", {
    offset: ".34",
    stopColor: "#4CB0C8"
  }), ___EmotionJSX("stop", {
    offset: ".66",
    stopColor: "#40A9C2"
  }), ___EmotionJSX("stop", {
    offset: ".99",
    stopColor: "#2D9CB7"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#2C9BB7"
  })), ___EmotionJSX("linearGradient", {
    id: "paint4_linear_250_6714",
    x1: "1629.55",
    y1: "708.532",
    x2: "1626.35",
    y2: "695.703",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#50B3CA"
  }), ___EmotionJSX("stop", {
    offset: ".34",
    stopColor: "#4CB0C8"
  }), ___EmotionJSX("stop", {
    offset: ".66",
    stopColor: "#40A9C2"
  }), ___EmotionJSX("stop", {
    offset: ".99",
    stopColor: "#2D9CB7"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#2C9BB7"
  })), ___EmotionJSX("linearGradient", {
    id: "paint5_linear_250_6714",
    x1: "172.971",
    y1: "84.078",
    x2: "216.065",
    y2: "108.989",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#F4A9B9"
  }), ___EmotionJSX("stop", {
    offset: ".02",
    stopColor: "#F4A7B7"
  }), ___EmotionJSX("stop", {
    offset: ".37",
    stopColor: "#F191A3"
  }), ___EmotionJSX("stop", {
    offset: ".7",
    stopColor: "#F08497"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#EF8093"
  })), ___EmotionJSX("linearGradient", {
    id: "paint6_linear_250_6714",
    x1: "189.457",
    y1: "98.648",
    x2: "189.457",
    y2: "108.77",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#E8B3A3"
  }), ___EmotionJSX("stop", {
    offset: ".04",
    stopColor: "#EBB7A7"
  }), ___EmotionJSX("stop", {
    offset: ".22",
    stopColor: "#F3C4B3"
  }), ___EmotionJSX("stop", {
    offset: ".47",
    stopColor: "#F9CBBA"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#FACDBC"
  })), ___EmotionJSX("linearGradient", {
    id: "paint7_linear_250_6714",
    x1: "184.873",
    y1: "99.218",
    x2: "197.375",
    y2: "77.533",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#E8B3A3"
  }), ___EmotionJSX("stop", {
    offset: ".05",
    stopColor: "#EBB8A8"
  }), ___EmotionJSX("stop", {
    offset: ".21",
    stopColor: "#F4C4B3"
  }), ___EmotionJSX("stop", {
    offset: ".44",
    stopColor: "#F9CBBA"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#FACDBC"
  })), ___EmotionJSX("linearGradient", {
    id: "paint8_linear_250_6714",
    x1: "192.906",
    y1: "175.353",
    x2: "186.407",
    y2: "164.086",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#E8B3A3"
  }), ___EmotionJSX("stop", {
    offset: ".24",
    stopColor: "#F1C0AF"
  }), ___EmotionJSX("stop", {
    offset: ".58",
    stopColor: "#F8CAB9"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#FACDBC"
  })), ___EmotionJSX("linearGradient", {
    id: "paint9_linear_250_6714",
    x1: "1362.66",
    y1: "1086.05",
    x2: "1362.66",
    y2: "1011.86",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#E8B3A3"
  }), ___EmotionJSX("stop", {
    offset: ".04",
    stopColor: "#EBB7A7"
  }), ___EmotionJSX("stop", {
    offset: ".22",
    stopColor: "#F3C4B3"
  }), ___EmotionJSX("stop", {
    offset: ".47",
    stopColor: "#F9CBBA"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#FACDBC"
  })), ___EmotionJSX("linearGradient", {
    id: "paint10_linear_250_6714",
    x1: "124.353",
    y1: "84.382",
    x2: "124.353",
    y2: "108.77",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#EDECED"
  }), ___EmotionJSX("stop", {
    offset: ".461",
    stopColor: "#BEBEBE"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#717171"
  })), ___EmotionJSX("linearGradient", {
    id: "paint11_linear_250_6714",
    x1: "2013.33",
    y1: "1553.01",
    x2: "2013.33",
    y2: "1358.32",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#E8B3A3"
  }), ___EmotionJSX("stop", {
    offset: ".04",
    stopColor: "#EBB7A7"
  }), ___EmotionJSX("stop", {
    offset: ".22",
    stopColor: "#F3C4B3"
  }), ___EmotionJSX("stop", {
    offset: ".47",
    stopColor: "#F9CBBA"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#FACDBC"
  })), ___EmotionJSX("linearGradient", {
    id: "paint12_linear_250_6714",
    x1: "28545.1",
    y1: "9856.47",
    x2: "28545.1",
    y2: "18948.2",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#50B3CA"
  }), ___EmotionJSX("stop", {
    offset: ".34",
    stopColor: "#4CB0C8"
  }), ___EmotionJSX("stop", {
    offset: ".66",
    stopColor: "#40A9C2"
  }), ___EmotionJSX("stop", {
    offset: ".99",
    stopColor: "#2D9CB7"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#2C9BB7"
  })), ___EmotionJSX("linearGradient", {
    id: "paint13_linear_250_6714",
    x1: "171.889",
    y1: "131.295",
    x2: "174.811",
    y2: "131.295",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D1EAF1"
  }), ___EmotionJSX("stop", {
    offset: ".27",
    stopColor: "#CDE8EF"
  }), ___EmotionJSX("stop", {
    offset: ".54",
    stopColor: "#C1E4E9"
  }), ___EmotionJSX("stop", {
    offset: ".82",
    stopColor: "#ADDBE0"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9BD4D7"
  })), ___EmotionJSX("linearGradient", {
    id: "paint14_linear_250_6714",
    x1: "2707.26",
    y1: "6906.57",
    x2: "2834.71",
    y2: "6906.57",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D1EAF1"
  }), ___EmotionJSX("stop", {
    offset: ".27",
    stopColor: "#CDE8EF"
  }), ___EmotionJSX("stop", {
    offset: ".54",
    stopColor: "#C1E4E9"
  }), ___EmotionJSX("stop", {
    offset: ".82",
    stopColor: "#ADDBE0"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9BD4D7"
  })), ___EmotionJSX("linearGradient", {
    id: "paint15_linear_250_6714",
    x1: "136.593",
    y1: "170.229",
    x2: "147.655",
    y2: "170.229",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    offset: ".01",
    stopColor: "#6AC2BF"
  }), ___EmotionJSX("stop", {
    offset: ".45",
    stopColor: "#56BDB6"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#40B7AD"
  })), ___EmotionJSX("linearGradient", {
    id: "paint16_linear_250_6714",
    x1: "135.845",
    y1: "177.321",
    x2: "148.404",
    y2: "177.321",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#50B3CA"
  }), ___EmotionJSX("stop", {
    offset: ".32",
    stopColor: "#3DA7C0"
  }), ___EmotionJSX("stop", {
    offset: ".67",
    stopColor: "#309EB9"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#2C9BB7"
  })), ___EmotionJSX("linearGradient", {
    id: "paint17_linear_250_6714",
    x1: "2270",
    y1: "2638.89",
    x2: "2596.53",
    y2: "2638.89",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    offset: ".01",
    stopColor: "#6AC2BF"
  }), ___EmotionJSX("stop", {
    offset: ".45",
    stopColor: "#56BDB6"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#40B7AD"
  })), ___EmotionJSX("linearGradient", {
    id: "paint18_linear_250_6714",
    x1: "1371.49",
    y1: "472.061",
    x2: "1473.47",
    y2: "472.061",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#E8B3A3"
  }), ___EmotionJSX("stop", {
    offset: ".04",
    stopColor: "#EBB7A7"
  }), ___EmotionJSX("stop", {
    offset: ".22",
    stopColor: "#F3C4B3"
  }), ___EmotionJSX("stop", {
    offset: ".47",
    stopColor: "#F9CBBA"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#FACDBC"
  })), ___EmotionJSX("linearGradient", {
    id: "paint19_linear_250_6714",
    x1: "1457.19",
    y1: "532.957",
    x2: "1574.59",
    y2: "532.957",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    offset: ".01",
    stopColor: "#6AC2BF"
  }), ___EmotionJSX("stop", {
    offset: ".45",
    stopColor: "#56BDB6"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#40B7AD"
  })), ___EmotionJSX("linearGradient", {
    id: "paint20_linear_250_6714",
    x1: "1265.67",
    y1: "1899.65",
    x2: "1336.4",
    y2: "1899.65",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#E8B3A3"
  }), ___EmotionJSX("stop", {
    offset: ".04",
    stopColor: "#EBB7A7"
  }), ___EmotionJSX("stop", {
    offset: ".22",
    stopColor: "#F3C4B3"
  }), ___EmotionJSX("stop", {
    offset: ".47",
    stopColor: "#F9CBBA"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#FACDBC"
  })), ___EmotionJSX("linearGradient", {
    id: "paint21_linear_250_6714",
    x1: "893.957",
    y1: "950.888",
    x2: "954.766",
    y2: "950.888",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#E8B3A3"
  }), ___EmotionJSX("stop", {
    offset: ".04",
    stopColor: "#EBB7A7"
  }), ___EmotionJSX("stop", {
    offset: ".22",
    stopColor: "#F3C4B3"
  }), ___EmotionJSX("stop", {
    offset: ".47",
    stopColor: "#F9CBBA"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#FACDBC"
  })), ___EmotionJSX("linearGradient", {
    id: "paint22_linear_250_6714",
    x1: "994.105",
    y1: "3302.08",
    x2: "1072.57",
    y2: "3302.08",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    offset: ".01",
    stopColor: "#6AC2BF"
  }), ___EmotionJSX("stop", {
    offset: ".45",
    stopColor: "#56BDB6"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#40B7AD"
  })), ___EmotionJSX("linearGradient", {
    id: "paint23_linear_250_6714",
    x1: "994.105",
    y1: "2263.21",
    x2: "1072.57",
    y2: "2263.21",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#F4A9B9"
  }), ___EmotionJSX("stop", {
    offset: ".02",
    stopColor: "#F4A7B7"
  }), ___EmotionJSX("stop", {
    offset: ".37",
    stopColor: "#F191A3"
  }), ___EmotionJSX("stop", {
    offset: ".7",
    stopColor: "#F08497"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#EF8093"
  })), ___EmotionJSX("linearGradient", {
    id: "paint24_linear_250_6714",
    x1: "620.099",
    y1: "426.188",
    x2: "644.586",
    y2: "426.188",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#E8B3A3"
  }), ___EmotionJSX("stop", {
    offset: ".04",
    stopColor: "#EBB7A7"
  }), ___EmotionJSX("stop", {
    offset: ".22",
    stopColor: "#F3C4B3"
  }), ___EmotionJSX("stop", {
    offset: ".47",
    stopColor: "#F9CBBA"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#FACDBC"
  })), ___EmotionJSX("linearGradient", {
    id: "paint25_linear_250_6714",
    x1: "655.282",
    y1: "480.225",
    x2: "683.476",
    y2: "480.225",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    offset: ".01",
    stopColor: "#6AC2BF"
  }), ___EmotionJSX("stop", {
    offset: ".45",
    stopColor: "#56BDB6"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#40B7AD"
  })), ___EmotionJSX("linearGradient", {
    id: "paint26_linear_250_6714",
    x1: "151.277",
    y1: "1654.15",
    x2: "187.099",
    y2: "1671.83",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#50B3CA"
  }), ___EmotionJSX("stop", {
    offset: ".32",
    stopColor: "#3DA7C0"
  }), ___EmotionJSX("stop", {
    offset: ".67",
    stopColor: "#309EB9"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#2C9BB7"
  })), ___EmotionJSX("linearGradient", {
    id: "paint27_linear_250_6714",
    x1: "184.602",
    y1: "-1079.97",
    x2: "149.108",
    y2: "-1097.48",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#F4A9B9"
  }), ___EmotionJSX("stop", {
    offset: ".02",
    stopColor: "#F4A7B7"
  }), ___EmotionJSX("stop", {
    offset: ".37",
    stopColor: "#F191A3"
  }), ___EmotionJSX("stop", {
    offset: ".7",
    stopColor: "#F08497"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#EF8093"
  })), ___EmotionJSX("linearGradient", {
    id: "paint28_linear_250_6714",
    x1: "423.581",
    y1: "863.942",
    x2: "436.169",
    y2: "863.942",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#F4A9B9"
  }), ___EmotionJSX("stop", {
    offset: ".02",
    stopColor: "#F4A7B7"
  }), ___EmotionJSX("stop", {
    offset: ".37",
    stopColor: "#F191A3"
  }), ___EmotionJSX("stop", {
    offset: ".7",
    stopColor: "#F08497"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#EF8093"
  })), ___EmotionJSX("linearGradient", {
    id: "paint29_linear_250_6714",
    x1: "420.964",
    y1: "864.619",
    x2: "433.553",
    y2: "864.619",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#E8B3A3"
  }), ___EmotionJSX("stop", {
    offset: ".04",
    stopColor: "#EBB7A7"
  }), ___EmotionJSX("stop", {
    offset: ".22",
    stopColor: "#F3C4B3"
  }), ___EmotionJSX("stop", {
    offset: ".47",
    stopColor: "#F9CBBA"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#FACDBC"
  })), ___EmotionJSX("linearGradient", {
    id: "paint30_linear_250_6714",
    x1: "-78.727",
    y1: "944.978",
    x2: "-68.791",
    y2: "952.66",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#F4A9B9"
  }), ___EmotionJSX("stop", {
    offset: ".02",
    stopColor: "#F4A7B7"
  }), ___EmotionJSX("stop", {
    offset: ".37",
    stopColor: "#F191A3"
  }), ___EmotionJSX("stop", {
    offset: ".7",
    stopColor: "#F08497"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#EF8093"
  })), ___EmotionJSX("linearGradient", {
    id: "paint31_linear_250_6714",
    x1: "-81.034",
    y1: "943.721",
    x2: "-71.098",
    y2: "951.402",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#E8B3A3"
  }), ___EmotionJSX("stop", {
    offset: ".04",
    stopColor: "#EBB7A7"
  }), ___EmotionJSX("stop", {
    offset: ".22",
    stopColor: "#F3C4B3"
  }), ___EmotionJSX("stop", {
    offset: ".47",
    stopColor: "#F9CBBA"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#FACDBC"
  })), ___EmotionJSX("linearGradient", {
    id: "paint32_linear_250_6714",
    x1: "92.182",
    y1: "74.392",
    x2: "74.982",
    y2: "74.392",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#EF8093"
  }), ___EmotionJSX("stop", {
    offset: ".4",
    stopColor: "#EE7E91"
  }), ___EmotionJSX("stop", {
    offset: ".61",
    stopColor: "#EC768B"
  }), ___EmotionJSX("stop", {
    offset: ".78",
    stopColor: "#E86880"
  }), ___EmotionJSX("stop", {
    offset: ".92",
    stopColor: "#E25671"
  })), ___EmotionJSX("linearGradient", {
    id: "paint33_linear_250_6714",
    x1: "221.032",
    y1: "463.137",
    x2: "241.839",
    y2: "463.137",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#EF8093"
  }), ___EmotionJSX("stop", {
    offset: ".4",
    stopColor: "#EE7E91"
  }), ___EmotionJSX("stop", {
    offset: ".61",
    stopColor: "#EC768B"
  }), ___EmotionJSX("stop", {
    offset: ".78",
    stopColor: "#E86880"
  }), ___EmotionJSX("stop", {
    offset: ".92",
    stopColor: "#E25671"
  })), ___EmotionJSX("linearGradient", {
    id: "paint34_linear_250_6714",
    x1: "79.669",
    y1: "144.097",
    x2: "88.459",
    y2: "144.097",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#EF8093"
  }), ___EmotionJSX("stop", {
    offset: ".4",
    stopColor: "#EE7E91"
  }), ___EmotionJSX("stop", {
    offset: ".61",
    stopColor: "#EC768B"
  }), ___EmotionJSX("stop", {
    offset: ".78",
    stopColor: "#E86880"
  }), ___EmotionJSX("stop", {
    offset: ".92",
    stopColor: "#E25671"
  })), ___EmotionJSX("linearGradient", {
    id: "paint35_linear_250_6714",
    x1: "101.854",
    y1: "73.753",
    x2: "172.763",
    y2: "73.753",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#EF8093"
  }), ___EmotionJSX("stop", {
    offset: ".4",
    stopColor: "#EE7E91"
  }), ___EmotionJSX("stop", {
    offset: ".61",
    stopColor: "#EC768B"
  }), ___EmotionJSX("stop", {
    offset: ".78",
    stopColor: "#E86880"
  }), ___EmotionJSX("stop", {
    offset: ".92",
    stopColor: "#E25671"
  })), ___EmotionJSX("linearGradient", {
    id: "paint36_linear_250_6714",
    x1: "1746.78",
    y1: "2121.59",
    x2: "6903.79",
    y2: "2121.59",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#F4A9B9"
  }), ___EmotionJSX("stop", {
    offset: ".02",
    stopColor: "#F4A7B7"
  }), ___EmotionJSX("stop", {
    offset: ".37",
    stopColor: "#F191A3"
  }), ___EmotionJSX("stop", {
    offset: ".7",
    stopColor: "#F08497"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#EF8093"
  })), ___EmotionJSX("linearGradient", {
    id: "paint37_linear_250_6714",
    x1: "83.741",
    y1: "145.848",
    x2: "100.736",
    y2: "145.848",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#EF8093"
  }), ___EmotionJSX("stop", {
    offset: ".4",
    stopColor: "#EE7E91"
  }), ___EmotionJSX("stop", {
    offset: ".61",
    stopColor: "#EC768B"
  }), ___EmotionJSX("stop", {
    offset: ".78",
    stopColor: "#E86880"
  }), ___EmotionJSX("stop", {
    offset: ".92",
    stopColor: "#E25671"
  })), ___EmotionJSX("linearGradient", {
    id: "paint38_linear_250_6714",
    x1: "2784.66",
    y1: "579.606",
    x2: "3175.55",
    y2: "579.606",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#EF8093"
  }), ___EmotionJSX("stop", {
    offset: ".4",
    stopColor: "#EE7E91"
  }), ___EmotionJSX("stop", {
    offset: ".61",
    stopColor: "#EC768B"
  }), ___EmotionJSX("stop", {
    offset: ".78",
    stopColor: "#E86880"
  }), ___EmotionJSX("stop", {
    offset: ".92",
    stopColor: "#E25671"
  })), ___EmotionJSX("linearGradient", {
    id: "paint39_linear_250_6714",
    x1: "82.723",
    y1: "34.811",
    x2: "82.723",
    y2: "62.44",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#6AC2BF"
  }), ___EmotionJSX("stop", {
    offset: ".48",
    stopColor: "#67C1BD"
  }), ___EmotionJSX("stop", {
    offset: ".83",
    stopColor: "#5EBDB6"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#56BAB1"
  })), ___EmotionJSX("linearGradient", {
    id: "paint40_linear_250_6714",
    x1: "85.054",
    y1: "51.977",
    x2: "85.054",
    y2: "65.539",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#E8B3A3"
  }), ___EmotionJSX("stop", {
    offset: ".04",
    stopColor: "#EBB8A8"
  }), ___EmotionJSX("stop", {
    offset: ".21",
    stopColor: "#F4C4B3"
  }), ___EmotionJSX("stop", {
    offset: ".44",
    stopColor: "#F9CBBA"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#FACDBC"
  })), ___EmotionJSX("linearGradient", {
    id: "paint41_linear_250_6714",
    x1: "92.233",
    y1: "49.47",
    x2: "78.303",
    y2: "41.414",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#E8B3A3"
  }), ___EmotionJSX("stop", {
    offset: ".05",
    stopColor: "#ECB9A8"
  }), ___EmotionJSX("stop", {
    offset: ".2",
    stopColor: "#F4C4B4"
  }), ___EmotionJSX("stop", {
    offset: ".41",
    stopColor: "#F9CBBA"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#FACDBC"
  })), ___EmotionJSX("linearGradient", {
    id: "paint42_linear_250_6714",
    x1: "91.467",
    y1: "66.756",
    x2: "78.708",
    y2: "66.756",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#6FC7D8"
  }), ___EmotionJSX("stop", {
    offset: ".43",
    stopColor: "#71C7D9"
  }), ___EmotionJSX("stop", {
    offset: ".65",
    stopColor: "#79C7DC"
  }), ___EmotionJSX("stop", {
    offset: ".82",
    stopColor: "#86C8E2"
  }), ___EmotionJSX("stop", {
    offset: ".96",
    stopColor: "#99C9EA"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9FC9ED"
  })), ___EmotionJSX("linearGradient", {
    id: "paint43_linear_250_6714",
    x1: "85.561",
    y1: "60.977",
    x2: "117.839",
    y2: "93.295",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    offset: ".01",
    stopColor: "#E9E9E9"
  }), ___EmotionJSX("stop", {
    offset: ".07",
    stopColor: "#ECECEC"
  }), ___EmotionJSX("stop", {
    offset: ".32",
    stopColor: "#F3F2F3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#F5F4F5"
  })), ___EmotionJSX("linearGradient", {
    id: "paint44_linear_250_6714",
    x1: "3744.15",
    y1: "1763.02",
    x2: "4373.77",
    y2: "1763.02",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    offset: ".01",
    stopColor: "#E9E9E9"
  }), ___EmotionJSX("stop", {
    offset: ".07",
    stopColor: "#ECECEC"
  }), ___EmotionJSX("stop", {
    offset: ".32",
    stopColor: "#F3F2F3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#F5F4F5"
  })), ___EmotionJSX("linearGradient", {
    id: "paint45_linear_250_6714",
    x1: "930.639",
    y1: "650.802",
    x2: "1048.57",
    y2: "650.802",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#F4A9B9"
  }), ___EmotionJSX("stop", {
    offset: ".02",
    stopColor: "#F4A7B7"
  }), ___EmotionJSX("stop", {
    offset: ".37",
    stopColor: "#F191A3"
  }), ___EmotionJSX("stop", {
    offset: ".7",
    stopColor: "#F08497"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#EF8093"
  }))));
};

export default withIllustrationWrapper( /*#__PURE__*/forwardRef(IllustrationTlcAdvantage3));
//# sourceMappingURL=IllustrationTlcAdvantage3.js.map